import * as React from "react";
import Panel from "../core/Panel";

function ToggleOnboardComplete({
  complete,
  toggle,
  toggling,
}: {
  complete: boolean;
  toggle: () => void;
  toggling: boolean;
}) {
  let buttonContent,
    labelClass = complete ? "label-success" : "label-warning";

  if (toggling) {
    buttonContent = <i className={"fa fa-spin fa-circle-o-notch"} />;
  } else if (complete) {
    buttonContent = "Mark Incomplete";
  } else {
    buttonContent = "Mark Complete";
  }

  return (
    <Panel heading={"Status"}>
      <h4 className={complete ? "text-success" : ""}>
        Onboarding {complete ? "Complete" : "Incomplete"}{" "}
        <i className={`fa ${complete ? "fa-check" : "fa-times"}`} />
      </h4>
      <button className={`btn btn-info btn-sm`} onClick={toggle}>
        {buttonContent}
      </button>
    </Panel>
  );
}

export default ToggleOnboardComplete;



// WEBPACK FOOTER //
// ./app/javascript/components/admin/ToggleOnboardComplete.tsx